import { http } from '@/api/client/httpClient';
import type { TenantConfigurationDto } from '@/api/types/tenantConfiguration';

// Routes derived from ABP conventional-controller mapping of
// Finkit.Tenants.Admin.TenantConfigurationAppService:
//   GetAsync()         -> GET /api/app/tenant-configuration
//   UpdateAsync(input) -> PUT /api/app/tenant-configuration
const BASE = '/api/app/tenant-configuration';

export const tenantConfigurationApi = {
  async get(): Promise<TenantConfigurationDto> {
    const { data } = await http.get<TenantConfigurationDto>(BASE);
    return data;
  },

  async update(input: TenantConfigurationDto): Promise<void> {
    await http.put(BASE, input);
  },
};
